import useSubscriptionInfo from "@/hooks/useSubscriptionInfo";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Usage() {
  const {
    planName,
    maxReports,
    maxAIGenerations,
    reportsUsed,
    aiGenerationsUsed,
    nextReset,
    loading,
    error,
  } = useSubscriptionInfo();

  const atReportLimit = reportsUsed >= maxReports;
  const atAILimit = aiGenerationsUsed >= maxAIGenerations;

  return (
    <div className="dashboard-content">
      <h1 className="dashboard-heading">Usage</h1>
      <p className="dashboard-subheading" style={{ marginBottom: "1.75rem" }}>
        Track your report card and AI generation usage.
      </p>

      {loading && <p className="text-muted-foreground">Loading...</p>}
      {error && <p className="text-destructive">Failed to load subscription info.</p>}

      {!loading && !error && (
        <div className="dashboard-content-narrow">
        <div className="space-y-6">
          <div className="border border-border rounded-lg p-4 bg-card space-y-1">
            <p className="text-sm text-muted-foreground uppercase tracking-wide">Current plan</p>
            <p className="text-2xl font-semibold capitalize">{planName}</p>
          </div>

          <div className="border border-border rounded-lg p-4 bg-card space-y-3">
            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>Report Cards</span>
                <span className={atReportLimit ? "text-destructive font-semibold" : ""}>
                  {reportsUsed} / {maxReports}
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${atReportLimit ? "bg-destructive" : "bg-primary"}`}
                  style={{ width: `${Math.min((reportsUsed / maxReports) * 100, 100)}%` }}
                />
              </div>
            </div>

            <div>
              <div className="flex justify-between text-sm mb-1">
                <span>AI Generations</span>
                <span className={atAILimit ? "text-destructive font-semibold" : ""}>
                  {aiGenerationsUsed} / {maxAIGenerations}
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${atAILimit ? "bg-destructive" : "bg-primary"}`}
                  style={{ width: `${Math.min((aiGenerationsUsed / maxAIGenerations) * 100, 100)}%` }}
                />
              </div>
            </div>

            {nextReset && (
              <p className="text-xs text-muted-foreground pt-1">
                Resets on {new Date(nextReset).toLocaleDateString()}
              </p>
            )}
          </div>

          {(atReportLimit || atAILimit) && (
            <div className="border border-destructive/40 rounded-lg p-4 bg-destructive/5">
              <p className="text-sm font-medium text-destructive mb-2">You have reached your plan limit.</p>
              <Link to="/pricing">
                <Button size="sm">Upgrade Plan</Button>
              </Link>
            </div>
          )}
        </div>
        </div>
      )}
    </div>
  );
}
